<template>
  <div class="radial-progress-bar">
    <svg :width="size" :height="size" viewBox="0 0 36 36">
      <circle
        class="radial-progress-bar__track"
        cx="18"
        cy="18"
        r="15.9155"
        fill="none"
        stroke="#444444"
        stroke-width="3"
      />
      <circle
        class="radial-progress-bar__progress"
        cx="18"
        cy="18"
        r="15.9155"
        fill="none"
        stroke="#70ffd4"
        stroke-width="3"
        stroke-dasharray="100, 100"
        :stroke-dashoffset="dashOffset"
        stroke-linecap="round"
        transform="rotate(-90 18 18)"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'RadialProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 100,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    dashOffset() {
      const circumference = 2 * Math.PI * 15.9155
      return circumference - (this.progress / 100) * circumference
    },
  },
}
</script>

<style scoped lang="scss">
.radial-progress-bar {
  display: flex;
  justify-content: center;
  align-items: center;

  &__progress {
    transition: stroke-dashoffset 0.6s ease;
  }
}
</style>
